import { dinero, toDecimal, type Dinero } from 'dinero.js';
import { MXN } from '@dinero.js/currencies';

/** Crea un Dinero MXN a partir de centavos enteros. */
export function mxn(centavos: number): Dinero<number> {
    return dinero({ amount: centavos, currency: MXN });
}

/** Formatea como string $X,XXX.XX MXN. */
export function formatMxn(amount: Dinero<number>): string {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(
        Number(toDecimal(amount)),
    );
}
